
import Const from '../constants'
import axiosApiInstance from '@/interceptors'

class ChatService {
  getGroupChats(data: any) {
    return axiosApiInstance.get(Const.api_url + 'group-chat/group-chat-user', {
      params: data
    })
  }

  markReadGroupChat(data: any) {
    return axiosApiInstance.post(Const.api_url + 'group-chat/update-check-user-unread', data)
  }

  markReadChatMention(data: any) { 
    return axiosApiInstance.post(`${Const.api_url}group-chat/update-check-user-unread-type-mention`, data)
  }

  markReadAllGroupChat() {
    return axiosApiInstance.post(Const.api_url + 'group-chat/read-all-group-chat')
  }

  pinGroupChat(payload: { id: number; is_pin: boolean }[]) {
    return axiosApiInstance.post(
      `${Const.api_url}group-chat/set-is-pin-group-chat`,
      payload
    )
  }

  getMessageById(messageId: string) {
    return axiosApiInstance.get(`${Const.api_url}message/${messageId}`)
  }
}

export default new ChatService
